<template>
  <div>
    <div class="l-company" @mouseenter="onCompanyEnter" @mouseleave="onCompanyLeave">
      <div class="l-company__inner" v-if="!isRendering">

        <!-- 代理店 or 労務サプリ -->
        <div class="l-company__wrap_old" v-if="isSupple || isProxy">
          <div class="l-company__left" style="margin-right: 25px;">
            <!-- 法人名 -->
            <p class="l-company__label" >法人名</p>
            <p class="l-company__name_old">{{ corpName }}</p>

            <!-- 企業の特徴 -->
            <div class="l-company__feature">
              <span>特徴を表示</span>
              <div class="l-company__detail-old">
                <CorporateFeatureInfoLabel
                  :isProxy="isProxy"
                  :isSupple="isSupple"
                  :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
                ></CorporateFeatureInfoLabel>
              </div>
            </div>
          </div>

          <div class="l-company__right">
            <div class="l-company__select_old" @click="showCorporateList(true)" v-if="corporateSelectable">
              <span>法人を切り替え</span>
            </div>
          </div>
        </div>

        <!-- ヨクスル -->
        <div class="l-company__wrap" v-if="!isSupple && !isProxy">
          <div class="l-company__left" style="margin-right: 25px;">
            <!-- 法人名 -->
            <p class="l-company__name" v-if="!isSupple && !isProxy">{{ corpName }}</p>
            <!-- 企業の特徴 -->
            <div class="l-company__feature" @mouseenter="onFeatureEnter">
              <span>特徴を表示</span>
              <div class="l-company__detail">
                <CorporateFeatureInfoLabel
                  :isProxy="isProxy"
                  :isSupple="isSupple"
                  :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
                ></CorporateFeatureInfoLabel>
              </div>
            </div>
            <!-- 事業場情報(ホバーでプレビュー) -->
            <div class="l-company__workspace" @mouseenter="onWorkspaceEnter">
              <span>事業場情報</span>
            </div>
            <!-- ナビゲーション -->
            <div>
              <nav class="l-company-nav" @mouseenter="onFeatureEnter">
                <ul v-if="isAdmin">
                  <li>
                    <a class="l-company-nav__link is-dashboard" @click="goTop()">カルテ</a>
                  </li>
                  <li :class="{'is-current' : $route.meta.globalMenuName === 'diag'}">
                    <a class="l-company-nav__link is-labor-audit" @click="goDiagTop()">労務監査</a>
                  </li>
                  <li :class="{'is-current' : $route.meta.globalMenuName === 'hr'}">
                    <a class="l-company-nav__link is-human-capital" @click="goHumanCapital()">人的資本管理</a>
                  </li>
                  <li :class="{'is-current' : $route.meta.globalMenuName === 'rough-diag'}">
                    <a class="l-company-nav__link is-mini-test" @click="goRoughDiagTop()">小テスト</a>
                  </li>
                  <li :class="{'is-current' : $route.meta.globalMenuName === 'corporate'}" v-if="isAdminUser">
                    <a class="l-company-nav__link is-company"  @click="goCorporate()">法人情報</a>
                  </li>
                </ul>
                <ul v-if="!isAllPermission && !isSystemAdmin && !isAdmin">
                  <li>
                    <a class="l-company-nav__link is-dashboard" @click="goTop()">カルテ</a>
                  </li>
                  <li :class="{'is-current' : $route.meta.globalMenuName === 'diag'}">
                    <a class="l-company-nav__link is-labor-audit" @click="goDiagTop()">労務監査</a>
                  </li>
                  <li :class="{'is-current' : $route.meta.globalMenuName === 'hr'}">
                    <a class="l-company-nav__link is-human-capital" @click="goHumanCapital()">人的資本管理</a>
                  </li>
                  <li :class="{'is-current' : $route.meta.globalMenuName === 'rough-diag'}">
                    <a class="l-company-nav__link is-mini-test" @click="goRoughDiagTop()">小テスト</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="l-company__right">
            <div class="l-company__select" @click="showCorporateList(true)" v-if="corporateSelectable">
              <span>法人を切り替え</span>
            </div>
          </div>
        </div>

        <div class="ls-name" v-if="isDiagAvailablePlan && !isAdmin">
          <p><span>管理法人：</span>{{ manageCorpName }}</p>
        </div>
      </div>

      <!-- 事業場情報プレビュー(ホバー表示・読み取り専用) -->
      <div class="ws-modal" :class="{ 'is-show': isShowWorkplaceModal }">
        <div class="ws-modal__dialog">
          <div v-if="wsWorkplaces.length > 0" class="ws-modal__scroll-wrap">
            <div class="ws-tbl">
              <div class="ws-row ws-row--head">
                <div class="ws-col ws-col--label">届出項目 / 事業場リスト</div>
                <div class="ws-col ws-col--place is-header" v-for="wp in wsWorkplaces" :key="wp.workplaceId">
                  <div class="ws-place-name"><span>{{ wp.workplaceName }}</span></div>
                  <span class="ws-employee-badge">{{ wsEmpLabel(wp.employeesType) }}</span>
                </div>
              </div>
              <div class="ws-row ws-row--note">
                <div class="ws-col ws-col--label"><span class="ws-note-icon"></span>備考</div>
                <div class="ws-col ws-col--place" v-for="wp in wsWorkplaces" :key="wp.workplaceId">
                  <span v-if="wp.remarks" class="ws-note-text" style="white-space: pre-wrap;">{{ wp.remarks }}</span>
                  <span v-else class="ws-note-placeholder">備考なし</span>
                </div>
              </div>
              <div
                v-for="item in wsItems"
                :key="item.workplaceNotificationItemId"
                class="ws-row ws-row--item"
                :class="item.judgmentType === 1 ? 'ws-row--auto' : 'ws-row--manual'"
              >
                <div class="ws-col ws-col--label">
                  <span class="ws-item-name">{{ item.notificationName }}<small v-if="item.supplement">{{ item.supplement }}</small></span>
                </div>
                <div
                  class="ws-col ws-col--place"
                  :class="{ 'is-alert': wsCell(wp.workplaceId, item.workplaceNotificationItemId).alert }"
                  v-for="wp in wsWorkplaces"
                  :key="wp.workplaceId"
                >
                  <span class="ws-status-label" :class="wsCell(wp.workplaceId, item.workplaceNotificationItemId).cls">{{ wsCell(wp.workplaceId, item.workplaceNotificationItemId).text }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="l-contentsBox l-resultBox">
            <h3 class="l-headding is-blue">事業場の情報が登録されていません。<template v-if="canEditWorkplace"><br>法人情報 から事業場を登録してください。</template></h3>
            <div v-if="canEditWorkplace" class="btn-basic is-inlne is-primary mt-30"><a @click="goWorkplaceList()">事業場を登録</a></div>
          </div>
        </div>
      </div>
    </div>
    <transition name="diagheadercorplist-fade">
      <CorporateListModal
        v-show="isShowCorporateList"
        @hide-corporate-list-modal="showCorporateList(false)"
        @select-corporate="emitSelectCorpList"
      ></CorporateListModal>
    </transition>
  </div>
</template>

<script>
import CorporateListModal from '@/components/pages/corporate/CorporateListModal.vue';
import CorporateFeatureInfoLabel from '@/components/parts/corporate/CorporateFeatureInfoLabel.vue';

// 従業員数区分ラベル(Workplace::EMP_TYPE_* に対応)
const WS_EMP_LABELS = {
  1: '0名',
  2: '1〜9名',
  3: '10〜49名',
  4: '50〜99名',
  5: '100〜299名',
  6: '300〜1000名',
  7: '1001名以上',
};

export default {
  components: {
    CorporateListModal,
    CorporateFeatureInfoLabel,
  },
  props: {
    corpName: {},
    manageCorpName: {},
    corporateFeatureInfoLabels: {},
    corporateSelectable: {
      'default': false,
    },
    isAdmin: {
      'default': false,
    },
    isDiagAvailablePlan: {
      'default': true,
    },
  },
  computed: {
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    isAdminUser() {
      return this.userAuthNo != 9;  // 一般ユーザ以外
    },
    isProxy() {
      return this.planId == 3;  // 代理店
    },
    canEditWorkplace() {
      return this.userAuthNo == 3;  // 事業場を編集できる(専門家ユーザ)
    },
  },
  watch: {
    corpId() {
      // 法人切替時はプレビューを閉じ、次回ホバー時に再取得する
      this.isShowWorkplaceModal = false;
      this.workplaceLoaded = false;
      this.wsWorkplaces = [];
      this.wsItems = [];
      this.wsStatuses = [];
    },
  },
  data() {
    return {
      isShowCorporateList: false,
      isSupple: false,
      userAuthNo: null,
      isAllPermission: false,
      isSystemAdmin: false,
      planId: null,
      isProcessing: false,
      isRendering: false,
      // 事業場情報プレビュー
      isShowWorkplaceModal: false,
      wsHideTimer: null,
      workplaceLoaded: false,
      wsWorkplaces: [],
      wsItems: [],
      wsStatuses: [],
    }
  },
  created: async function () {
    this.isProcessing = true;
    this.isRendering = true;
    const authority = await this.$store.dispatch('auth/getAuthority');
    this.isAdmin = authority.isAdmin;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;
    this.isAllPermission = authority.isAllPermission;
    this.isSystemAdmin = authority.isSystemAdmin;
    this.userAuthNo = authority.userAuthNo;
    this.isSupple = authority.isSupple;
    this.planId = authority.planId;
    this.isProcessing = false;
    this.isRendering = false;
  },
  methods: {
    showCorporateList(value) {
      this.isShowCorporateList = value;
    },
    // --- 事業場情報プレビュー(ホバー) ---
    async onWorkspaceEnter() {
      clearTimeout(this.wsHideTimer);
      if (!this.workplaceLoaded) {
        await this.fetchWorkplacePreview();
      }
      this.isShowWorkplaceModal = true;
    },
    onFeatureEnter() {
      clearTimeout(this.wsHideTimer);
      this.isShowWorkplaceModal = false;
    },
    onCompanyEnter() {
      clearTimeout(this.wsHideTimer);
    },
    onCompanyLeave() {
      this.wsHideTimer = setTimeout(() => {
        this.isShowWorkplaceModal = false;
      }, 150);
    },
    // 事業場保存後など、プレビューのキャッシュを無効化して次回ホバー時に再取得させる
    invalidateWorkplacePreview() {
      this.workplaceLoaded = false;
      this.wsWorkplaces = [];
      this.wsItems = [];
      this.wsStatuses = [];
    },
    async fetchWorkplacePreview() {
      if (!this.corpId) return;
      let res = await this.$axios.post('/ld/api/workplace/getWorkplaceData', { corpId: this.corpId });
      if (res) {
        this.wsWorkplaces = res.data.workplaces;
        this.wsItems = res.data.notificationItems;
        this.wsStatuses = res.data.statuses;
        this.workplaceLoaded = true;
      }
    },
    wsEmpLabel(employeesType) {
      return WS_EMP_LABELS[employeesType] || '';
    },
    // 読み取り専用ラベル: 不要 / 対応済 / 未対応(未対応はalert)/ 未選択は—
    wsCell(workplaceId, itemId) {
      const s = this.wsStatuses.find(
        (x) => x.workplaceId === workplaceId && x.workplaceNotificationItemId === itemId
      );
      if (!s || s.necessity == null) return { text: '—', cls: '', alert: false };
      if (s.necessity === 2) return { text: '不要', cls: 'is-na', alert: false };
      if (s.status === 1) return { text: '対応済', cls: 'is-done', alert: false };
      return { text: '未対応', cls: 'is-pending', alert: true };
    },
    goWorkplaceList() {
      this.$store.dispatch('user/setCorpId', this.corpId);
      this.$router.push({ name: 'workplace-list', query: { corpId: this.corpId } });
    },
    async emitSelectCorpList(params) {

      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);
      this.$store.dispatch('diag/setDiagResultId', null);

      this.$emit("select-corporate", {
        corpId: params.corpId,
        corpNm: params.corpNm,
      });
    },
    // 人的資本
    async goTop() {
      this.$router.replace({name: 'top', hash: 'section01'});
//      root.$router.push({ path: '/about', hash: 'title' })
    },
    async goHumanCapital() {
      this.$router.replace({path: '/hr/'+this.corpId+'/topparam'});
    },
    async goDiagTop() {
      if ( this.diagResultId != null ) {
        this.$router.replace({path: '/diag/'+this.corpId+'/'+this.diagResultId+'/topparam'});
      }else{
        let diagResultId = await this.getLatestDiagResultId(this.corpId);
        if ( diagResultId > 0 ) {
          this.$router.replace({path: '/diag/'+this.corpId+'/'+diagResultId+'/topparam'});
        }else{
          const params = {};
          this.$router.push({ name: 'diag-top', params: params });
        }
      }
    },
    goRoughDiagTop() {
      const params = {};
      this.$router.push({ name: 'rough-diag-list', params: params });
    },
    goCorporateList() {
      const params = {};
      this.$router.push({ name: 'corporate-list', params: params });
    },
    goCorporate() {
      // ここでuserのsetCorpIdに設定して遷移する
      this.$store.dispatch('user/setCorpId', this.corpId);
      this.$router.push({ name: 'corporate-edit', query: { corpId: this.corpId } });
    },
    async getLatestDiagResultId(corpId) {
      this.isRendering = true;
      this.isProcessing = true;

      if (corpId) {
        let res = await this.$axios.post('/ld/api/diag/getLatestDiagResultId', {
          corpId: corpId
        });
        if (res.status) {
          this.isRendering = false;
          this.isProcessing = false;
          return res.data.diagResultId;
        }else{
          this.isRendering = false;
          this.isProcessing = false;
        }
      }
    },
  }
}

</script>

<style scoped>
.l-company {
  position: relative;
}
.diagheadercorplist-fade-enter-active {
  transition: all .2s ease;
}
.diagheadercorplist-fade-leave-active {
  transition: all .2s ease;
}
.diagheadercorplist-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.diagheadercorplist-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}


</style>
